import { columnHelper } from './helper';

export const roleName = columnHelper.accessor((row) => row.name, {
  header: 'Role Name',
  id: 'roleName',
  cell: ({ row }) => <div className="flex">{row.original.roleRef.name}</div>,
});
